import { CommonModule } from '@angular/common';
import {
  Component,
  EventEmitter,
  HostBinding,
  Input,
  Output,
} from '@angular/core';

import { UmssIconComponent } from '../icon/icon.component';

@Component({
  selector: 'umss-tab',
  standalone: true,
  imports: [CommonModule, UmssIconComponent],
  templateUrl: './tab.component.html',
  styleUrls: ['./tab.component.scss'],
})
export class UmssTabComponent {
  @HostBinding('style.display') display = 'contents';

  constructor() {}

  /** Content props */
  @Input() label: string = 'Label';
  @Input() iconName?: string; // Phosphor icon name (e.g., 'phosphorHouse', 'phosphorUser')
  @Input() counter?: number;
  @Input() showCounter: boolean = false;

  /** Variant props */
  @Input() content: 'Label' | 'Icon' | 'Icon + Label' = 'Label';
  @Input() size: 'Small' | 'Regular' | 'Large' = 'Regular';
  @Input() fullWidth = false;

  /** State props */
  @Input() active: boolean = false;
  @Input() disabled: boolean = false;
  @Input() hover: boolean = false;

  /** Computed properties for content visibility */
  get showLabel(): boolean {
    return this.content === 'Label' || this.content === 'Icon + Label';
  }

  get showIcon(): boolean {
    return (
      (this.content === 'Icon' || this.content === 'Icon + Label') &&
      !!this.iconName
    );
  }

  get iconSize(): string {
    switch (this.size) {
      case 'Small':
        return '16px';
      case 'Regular':
        return '20px';
      case 'Large':
        return '24px';
      default:
        return '20px';
    }
  }

  /** Event outputs */
  @Output() tabClick = new EventEmitter<void>();

  /** Event handlers */
  onTabClick(): void {
    if (this.disabled) return;
    this.tabClick.emit();
  }

  /** Computed properties */
  get counterDisplay(): string {
    if (!this.counter) return '';
    return this.counter > 99 ? '99+' : this.counter.toString();
  }
}
